module.exports = __webpack_public_path__ + "static/media/hcp-favicon.af92787a.ico";